import { render, staticRenderFns } from "./PaymentContent.vue?vue&type=template&id=24659620"
import script from "./PaymentContent.vue?vue&type=script&lang=js"
export * from "./PaymentContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports